import React from "react";
import PropTypes from "prop-types";

class PhoneNumberTd extends React.Component {
  render() {
    return (
      <td className={this.props.fieldClassName}>
        {this.props.fieldValue ? (
          <span>
            {this.props.hideField ? (
              "-"
            ) : (
              <a
                className="styled-link pointer-hand"
                href={"tel:" + this.props.fieldValue}
              >
                {this.props.fieldValue}
              </a>
            )}
          </span>
        ) : (
          "-"
        )}
      </td>
    );
  }
}

PhoneNumberTd.propTypes = {
  fieldValue: PropTypes.string,
  fieldClassName: PropTypes.string,
  hideField: PropTypes.bool,
};

export default PhoneNumberTd;
